import { CardBlockImage } from "entities/modules/types";
import { Timestamp, collection, doc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { PageModuleDataToUpdate } from "../types";
import { savePageContentBlocksModuleImage } from "./savePageContentBlocksModuleImage";
import { savePageTopPrivacyTipsBlockModuleImage } from "./savePageTopPrivacyTipsBlockModuleImage";

type Params = {
  moduleId: string;
  moduleData: PageModuleDataToUpdate;
  brandId: string;
  pageId: string;
  cardBlockImages: CardBlockImage[];
  topPrivacyTipsBlockImage: CardBlockImage;
};

export const updatePageModule = async ({
  moduleData,
  moduleId,
  pageId,
  brandId,
  cardBlockImages,
  topPrivacyTipsBlockImage,
}: Params): Promise<void> => {
  const collectionRef = collection(
    db,
    `brands/${brandId}/pages/${pageId}/modules`,
  );
  await updateDoc(doc(collectionRef, moduleId), {
    ...moduleData,
    updatedAt: Timestamp.now(),
  });

  if (cardBlockImages.some((item) => item instanceof File)) {
    await savePageContentBlocksModuleImage({
      brandId,
      moduleId,
      pageId,
      cardBlockImages,
    });
  }

  if (topPrivacyTipsBlockImage instanceof File) {
    await savePageTopPrivacyTipsBlockModuleImage({
      brandId,
      moduleId,
      pageId,
      topPrivacyTipsBlockImage,
    });
  }
};
